import { memo } from 'react'

export const Environment = memo(() => (
  <>
    <ambientLight intensity={0.7} />
    <directionalLight
      castShadow
      position={[3, 5, 1]}
      intensity={0.5}
      shadow-mapSize-width={1024} // Higher values give better shadow resolution
      shadow-mapSize-height={1024} // Higher values give better shadow resolution
      shadow-camera-left={-10} // Increase or decrease to adjust frustum size
      shadow-camera-right={10} // Increase or decrease to adjust frustum size
      shadow-camera-top={10} // Increase or decrease to adjust frustum size
      shadow-camera-bottom={-10} // Increase or decrease to adjust frustum size
      shadow-camera-near={1} // Adjust based on your scene's depth
      shadow-camera-far={100} // Ensure this covers the distance to the furthest object casting shadows
    />

  </>
))
